import { Backdrop, CircularProgress } from '@mui/material';
import { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { greenColor } from '../../config/colors';
import { HOST_REDUTO, HOST_API } from '../../config/hosts';
import LogoReduto from './../../assets/logo.png';

export function Logo() {
  return (
    <img
      src={LogoReduto}
      alt="logo reduto"
      style={{
        width: 250,
        marginBottom: 30,
      }}
    />
  );
}

export default function ComponentLeadForm() {
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [telefone, setTelefone] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    document.title = 'Contato';
  }, []);

  const handleSubmit = async () => {
    if (!nome || !email || !telefone || !mensagem) {
      toast.warning('Preencha todos os campos', { theme: 'dark' });
      return;
    }

    setIsLoading(true);
    try {
      const res = await fetch(`${HOST_API}/v1/contato/lead`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nome, email, telefone, mensagem }),
      });

      if (!res.ok) {
        throw new Error('Erro ao enviar');
      }

      toast.success('Obrigado! Sua mensagem foi enviada com sucesso.', {
        theme: 'dark',
      });

      setNome('');
      setEmail('');
      setTelefone('');
      setMensagem('');
    } catch (err) {
      toast.error('Erro ao enviar. Tente novamente.', { theme: 'dark' });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <form>
        <section className="w-full sm:fixed justify-center items-center bg-gradient-to-r from-[#0e0d0dee] via-[#090808] via-90% to-[#000000]">
          <ToastContainer />
          <section className="w-full min-h-screen justify-center p-[20px] sm:flex sm:flex-col sm:justify-center sm:items-center text-center">
            <div className="w-full pb-[10px] flex flex-col justify-center items-center">
              <Logo />

              {/* Texto institucional */}
              <p className="text-[#fafafa] text-lg max-w-[900px] text-center mb-[30px] leading-relaxed">
                <strong>Preencha o formulário abaixo</strong> com seus dados e informações sobre sua
                necessidade. Nossa equipe comercial receberá sua mensagem e entrará em contato o
                mais breve possível para apresentar soluções personalizadas e responder a todas as
                suas dúvidas. Estamos prontos para ajudar você a encontrar as melhores oportunidades
                com a <span className="text-[#83d84d] font-bold">Reduto Capital</span>.
              </p>

              <div className="w-full mt-[10px] flex flex-col items-center text-left">
                {/* Nome */}
                <div className="w-full h-[60px] sm:max-w-[400px] border-b-2 border-gray-400 hover:border-[#83d84d] duration-100">
                  <label className="text-[#fafafa] text-lg">Nome</label>
                  <input
                    type="text"
                    className="w-full bg-[#0f1010] p-2 outline-0 text-[#83d84d] mt-[3px]"
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                  />
                </div>

                {/* Email */}
                <div className="w-full h-[60px] sm:max-w-[400px] border-b-2 border-gray-400 hover:border-[#83d84d] duration-100 mt-[15px]">
                  <label className="text-[#fafafa] text-lg">E-mail</label>
                  <input
                    type="email"
                    className="w-full bg-[#0f1010] p-2 outline-0 text-[#83d84d] mt-[3px]"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>

                {/* Telefone */}
                <div className="w-full h-[60px] sm:max-w-[400px] border-b-2 border-gray-400 hover:border-[#83d84d] duration-100 mt-[15px]">
                  <label className="text-[#fafafa] text-lg">Telefone</label>
                  <input
                    type="tel"
                    className="w-full bg-[#0f1010] p-2 outline-0 text-[#83d84d] mt-[3px]"
                    value={telefone}
                    onChange={(e) => setTelefone(e.target.value)}
                  />
                </div>

                {/* Mensagem */}
                <div className="w-full sm:max-w-[400px] border-b-2 border-gray-400 hover:border-[#83d84d] duration-100 mt-[15px]">
                  <label className="text-[#fafafa] text-lg">Mensagem</label>
                  <textarea
                    rows="4"
                    className="w-full bg-[#0f1010] p-2 outline-0 text-[#83d84d] mt-[3px]"
                    value={mensagem}
                    onChange={(e) => setMensagem(e.target.value)}
                  />
                </div>

                {/* Botão */}
                <div className="w-full sm:max-w-[400px] mt-[20px]">
                  <button
                    className="w-full h-[40px] bg-[#83d84d] rounded-md text-lg font-bold"
                    onClick={(event) => {
                      event.preventDefault();
                      handleSubmit();
                    }}
                  >
                    Enviar
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* Modal de carregamento */}
          <Backdrop open={isLoading} style={{ zIndex: 9999 }}>
            <CircularProgress color="inherit" sx={{ color: greenColor }} />
          </Backdrop>
        </section>
      </form>
    </div>
  );
}
